import React from 'react';
import './ImageUpload.css';

const ImageUpload = ({ images, onAdd, onRemove, multiple = true, id = "image-upload" }) => {
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      onAdd(files);
    }
    // Reset input value to allow the same file to be selected again if needed
    e.target.value = '';
  };

  return (
    <div className="image-management-row">
      {images.map((img, index) => {
        const imageUrl = img?.url?.url || img?.url || img;
        return (
          <div key={index} className="preview-item">
            <img src={imageUrl} alt={`Preview ${index}`} />
            <button 
              type="button" 
              className="remove-image-btn" 
              onClick={() => onRemove(index)}
              title="Remove Image"
            >
              &times;
            </button>
          </div>
        );
      })}

      {(multiple || images.length === 0) && (
        <div className="image-upload-wrapper">
          <input
            type="file"
            multiple={multiple}
            accept="image/*"
            onChange={handleFileChange}
            className="file-input-hidden"
            id={id}
          />
          <label htmlFor={id} className="mini-upload-box">
            <span className="upload-icon">+</span>
            <span>Add Image</span>
          </label>
        </div>
      )}
    </div>
  );
};

export default ImageUpload;
